import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./state/store";

import App from "./components/app";
import "./components/app.css";
import "../env";

import "@abgov/web-components";

const root = ReactDOM.createRoot(document.getElementById("root")!);

fetch("/config/config.json").then(() => {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  );
});
